import React, { useEffect } from 'react';
import { useAuth, hasAuthParams } from 'react-oidc-context';

const RETRY_KEY = 'authCallbackRetried';

// Landing page for the Cognito redirect_uri. react-oidc-context only completes the
// login when the URL carries both `code` and `state`; Cognito's post-signup redirect
// (e.g. after confirming the account) can arrive without them, which used to leave
// this page spinning forever. In that case start a fresh login: the Cognito session
// created during signup makes it bounce straight back with a valid callback.
const AuthCallback = () => {
  const auth = useAuth();

  useEffect(() => {
    if (auth.isLoading || auth.isAuthenticated || auth.error || auth.activeNavigator) {
      return;
    }
    if (hasAuthParams()) {
      return;
    }

    let alreadyRetried = false;
    try {
      alreadyRetried = sessionStorage.getItem(RETRY_KEY) === '1';
      sessionStorage.setItem(RETRY_KEY, '1');
    } catch (err) {
      // Storage unavailable: retry once anyway
    }

    if (alreadyRetried) {
      // Avoid a redirect loop; send the user to the welcome screen instead
      try {
        sessionStorage.removeItem(RETRY_KEY);
      } catch (err) {
        // ignore
      }
      window.location.replace('/');
      return;
    }

    auth.signinRedirect();
  }, [auth]);

  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>Procesando inicio de sesión...</p>
    </div>
  );
};

export const clearAuthCallbackRetry = () => {
  try {
    sessionStorage.removeItem(RETRY_KEY);
  } catch (err) {
    // ignore
  }
};

export default AuthCallback;
